interface AsIsSourceCodeTextParams {
    name: string;
    code: string | null;
}

/**
 * QuickBooks joins an account's ancestry into a single cell with `:`, and
 * disallows a literal colon inside a leaf's own name precisely because it is
 * the path separator, so the last segment is unambiguously the leaf.
 */
export function leafSegment(name: string): string {
    return name.slice(name.lastIndexOf(":") + 1);
}

/**
 * Re-import matching has to use the source number before collision suffixes:
 * `resolveAsIsCodeTexts` would push every coded row off the chart it is
 * trying to match.
 */
export function asIsSourceCodeText({
    name,
    code,
}: AsIsSourceCodeTextParams): string | null {
    // Named exports put the `Parent:Child` path in `code`; blank numbers
    // fall back to the child name. Compare leaves so either leftover path
    // is not treated as a code.
    if (code === null || leafSegment(code) === leafSegment(name)) {
        return null;
    }
    return code;
}
